import React, { useEffect, useState } from 'react';

const barColor = (value) =>
  value >= 90 ? 'var(--score-green)' : value >= 80 ? 'var(--score-amber)' : 'var(--score-red)';

const ScoreBar = ({ label, value }) => {
  const numValue = Math.min(100, Number(value) || 0);
  const [animated, setAnimated] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setAnimated(numValue), 80);
    return () => clearTimeout(t);
  }, [numValue]);

  const color = barColor(numValue);

  return (
    <div className="score-bar-row">
      <span className="score-bar-label" title={label}>{label}</span>
      <div className="score-bar-track">
        <div
          className="score-bar-fill"
          style={{ width: `${animated}%`, background: color }}
        />
      </div>
      <span className="score-bar-value" style={{ color }}>{numValue}%</span>
    </div>
  );
};

export default ScoreBar;
